<template>
<div>
    <div v-if="done && companyName === null && selectedUnitInfoList.length == 0 && unselectedUnitInfoList.length == 0">
        <div class="area_indexBox"><h1>Area Not Set Yet</h1></div>
    </div>
    <div v-else>
        <div class="area_indexBox" v-if="!editStatus">
            <h1>{{companyName}}</h1>
            <h2 v-if="selectedUnitInfoList.length > 0">Selected Area</h2>
            <div class="boxs" v-if="selectedUnitInfoList.length > 0">
                <div class="box" v-for="(item, index) in selectedUnitInfoList" :key="index">
                    {{item.OperationalUnitName ? item.OperationalUnitName : 'Area Not Set Yet'}}</div>
            </div>
            <h2 v-if="unselectedUnitInfoList.length > 0">Excluded Area</h2>
            <div class="boxs" v-if="unselectedUnitInfoList.length > 0">
                <div class="box" v-for="(item, index) in unselectedUnitInfoList" :key="index">
                    {{item.OperationalUnitName ? item.OperationalUnitName : 'Area Not Set Yet'}}</div>
            </div>
        </div>
        <div class="area_indexBox" v-if="editStatus">
            <h1>Please select area</h1>
            <h2>Multiple Choice</h2>
            <div class="boxs">
                <div class="box-check clear" v-for="(item, index) in editList"
                @click="item.checked = !item.checked" :key="index"
                :class="{'box-checked': item.checked}">{{item.OperationalUnitName}}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import api from '../../api/api';

export default {
    props:{
        areaId:{
            type: [String, Number],
            default: () => {
                return '';
            }
        },
        timeToSave:{
            type: Boolean,
            default: () => {
                return false;
            }
        }
    },
	data() {
		return {
            editStatus: false,
            editList: [],
            companyName: '',
            selectedUnitInfoList: [],
            unselectedUnitInfoList: [],
            done: false
        }
	},
	methods:{
        getLst() {
            this.companyName = ''
            this.selectedUnitInfoList = []
            this.unselectedUnitInfoList = []
            api.areaCompanyInfoTanda({
                callback: (res) => {
                    this.done = true
                    if (res.data.code === 0) {
                        if (!res.data.data.companyName && !res.data.data.selectedUnitInfoList && !res.data.data.unselectedUnitInfoList){
                            this.companyName = res.data.data.companyName
                            this.$emit('noData')
                            return
                        }
                        this.companyName = res.data.data.companyName
                        this.selectedUnitInfoList = res.data.data.selectedUnitInfoList ? res.data.data.selectedUnitInfoList : []
                        this.unselectedUnitInfoList = res.data.data.unselectedUnitInfoList ? res.data.data.unselectedUnitInfoList : []
                    } else {
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            })
        }
    },
    mounted() {
        this.getLst()
    },
    watch: {
        'areaId': {
            deep: true,
            handler: function (val) {
                // 得到一个id，请求列表展示，进入编辑状态
                if (val === '') {
                    this.editStatus = false
                    this.getLst()
                    return
                }
                this.editList = []
                api.areaTandaList({
                    params: val,
                    callback: (res) => {
                        if (res.data.code === 0) {
                            res.data.data.forEach(item => {
                                item.checked = false
                                this.editList.push(item)
                            })
                        } else {
                            Utils.alert('', res.data.message, 'error')
                        }
                    }
                })
                this.editStatus = true
            }
        },
        'timeToSave': {
            deep: true,
            handler: function (val) {
                if (!val)
                    return
                // 调用保存接口
                let temp = []
                this.editList.forEach(i => {
                    if (i.checked)
                        temp.push(i)
                })
                this.$emit('save', temp)
            }
        }
    }
}
</script>

<style lang="scss">
.area_indexBox{
    width: 100%;
    margin: 35px 0;
    padding: 20px 0 50px 0;
    background: var(--background-color-3);
    h1{
        word-break: break-word;
        margin-bottom: 37px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-color);
        line-height: 28px;
        box-sizing: border-box;
        padding: 0 10px;
    }
    h2{
        word-break: break-word;
        margin-bottom: 16px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 28px;
        box-sizing: border-box;
        padding: 0 10px;
    }
    .boxs{
        margin-bottom: 46px;
        border-right: 1px solid #5F5F5F;
        border-left: 1px solid #5F5F5F;
        border-top: 1px solid #5F5F5F;
    }
    .box{
        word-break: break-word;
        border-bottom: 1px solid #5F5F5F;
        box-sizing: border-box;
        padding: 14px 0 14px 10px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-color);
        line-height: 32px;
    }
    .box-check{
        word-break: break-word;
        border-bottom: 1px solid #5F5F5F;
        box-sizing: border-box;
        padding: 14px 0 14px 46px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-color);
        line-height: 32px;
        background-repeat: no-repeat;
		background-position: 10px center;
		background-size: 16px 16px;
		background-image: url('../../assets/p2.png');
        cursor: pointer;
    }
    .box-checked{
        background-image: url('../../assets/p1.png') !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/rosterAndLabour/tandaArea.vue